import { Component, Input } from '@angular/core';
import { XpressDeliveryOrderDetail, TextTransformType } from '@shared/models';

@Component({
	selector: 'booking-payment-tab',
	templateUrl: './booking-payment-tab.component.html',
	styleUrl: './booking-payment-tab.component.scss'
})
export class BookingPaymentTabComponent {
	@Input() deliveryOrderDetails!: XpressDeliveryOrderDetail;
	TextTransformType = TextTransformType;

	formatCurrency(amount: number | undefined): string {
		if (!amount) { return '--'; }
		return new Intl.NumberFormat('en-PH', {
			style: 'currency',
			currency: 'PHP'
		}).format(amount);
	}
}
